import { ANALYTICS_EVENTS, ANALYTICS_PROPERTY_KEYS, COMPONENT_OUTCOMES, DCM_PAGES } from '../constants';
import { trackAnalyticsEvent } from '../core/analyticsClient';

export const trackReportExported = (reportName: string, reportType?: string): void => {
  trackAnalyticsEvent(ANALYTICS_EVENTS.REPORT_EXPORTED, {
    [ANALYTICS_PROPERTY_KEYS.REPORT_NAME]: reportName,
    ...(reportType ? { [ANALYTICS_PROPERTY_KEYS.REPORT_TYPE]: reportType } : {}),
    [ANALYTICS_PROPERTY_KEYS.PAGE]: DCM_PAGES.REPORTS,
    [ANALYTICS_PROPERTY_KEYS.COMPONENT_OUTCOME]: COMPONENT_OUTCOMES.USER,
  });
};
